export const getImagePaths = ({
  basePath,
  pathExtension = ".jpg",
  startIndex = 1,
}: {
  basePath: string;
  pathExtension?: string;
  startIndex?: number;
}): Promise<string[]> => {
  const existingImages: string[] = [];
  let index = startIndex;

  return new Promise((resolve) => {
    const checkNext = async () => {
      const imagePath = `${basePath}${index}${pathExtension}`;

      try {
        const response = await fetch(imagePath, { method: "HEAD" });
        if (response.ok) {
          existingImages.push(imagePath);
          index += 1;
          checkNext();
        } else {
          resolve(existingImages);
        }
      } catch {
        resolve(existingImages);
      }
    };

    checkNext();
  });
};
